// API Configuration for Sudesh Maths Portal

export const API_BASE_URL = 'https://sudeshmaths.com/api';
// export const API_BASE_URL = 'http://localhost/sudesh/api';
// export const API_BASE_URL = "http://192.168.8.1/sudesh/api";
/**
 * Helper to handle fetch requests to the PHP API
 * @param {string} endpoint e.g. '/auth/login.php'
 * @param {object} options fetch options
 */
export async function fetchAPI(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;

    // Default headers for JSON
    const defaultHeaders = options.body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' };

    try {
        const response = await fetch(url, {
            ...options,
            credentials: 'include', // Include cookies for session management
            headers: {
                ...defaultHeaders,
                ...options.headers,
            },
        });

        const result = await response.json();

        if (result.status === 'success') {
            // Return result.data if it exists, otherwise return the whole result so the message is accessible
            return result.data !== null ? result.data : result;
        } else if (result.status === 'busy') {
            // For busy status, return the whole result so the waiting room logic can triggers
            return result;
        } else {
            throw new Error(result.message || 'API request failed');
        }
    } catch (error) {
        console.error(`API Error (${endpoint}):`, error);
        throw error;
    }
}
